<template>
  <b-modal v-model="localShowModal" size="xl" :title="`Historical Log Detail Actual - ${detail.activity}`" 
    @hide="resetModal()" hide-footer>
    <div class="container-fluid">
      <div v-if="isLoading" class="row mb-3">
        <!-- Skeleton loader, misalnya tampilkan placeholder -->
        <b-skeleton animation="wave" width="100%"></b-skeleton>
        <b-skeleton animation="wave" width="100%"></b-skeleton>
        <b-skeleton animation="wave" width="100%"></b-skeleton>
        <b-skeleton animation="wave" width="100%"></b-skeleton>
        <!-- Tambahkan skeleton untuk seluruh konten yang memerlukan data -->
      </div>

      <div v-else>
        <!-- Bagian Header -->
        <div class="row mb-3">
          <div class="col-md-3">
              <strong>GL</strong>
              <p>{{ logData.budget_gl || '-' }}</p>
          </div>
          <div class="col-md-3">
              <strong>Budget Task</strong>
              <p>{{ logData.budget_task || '-' }}</p>
          </div>

          <div class="col-md-3">
              <strong>Total Budget</strong>
              <p>Rp. {{ convertNumber(logData.total_budget_task) || '0' }}</p>
          </div>
          <div class="col-md-3">
              <strong>Total PO Value</strong>
              <p>Rp. {{ convertNumber(logData.total_po_value) || '0' }}</p>
          </div>
          <div class="col-md-3">
              <strong>BRS In</strong>
              <p>Rp. {{ convertNumber(logData.brs_in) || '0' }}</p>
          </div>
          <div class="col-md-3">
              <strong>BRS Out</strong>
              <p>Rp. {{ convertNumber(logData.brs_out) || '0' }}</p>
          </div>

          <div class="col-md-3">
              <strong>Remaining Budget</strong>
              <p>Rp. {{ convertNumber(logData.remaining_budget_task) || '0' }}</p>
          </div>
          <div class="col-md-3">
              <strong>PR Name</strong>
              <p>{{ logData.pr_name || '-' }}</p>
          </div>
          <div class="col-md-3">
              <strong>PR Number</strong>
              <p>{{ logData.pr_number || '-' }}</p>
          </div>
          <div class="col-md-3">
              <strong>PO Number</strong>
              <p>{{ logData.po_number || '-' }}</p>
          </div>

          <div class="col-md-3">
              <strong>PR Date</strong>
              <p>{{ logData.pr_date || '-' }}</p>
          </div>
          <div class="col-md-3">
              <strong>PO Date</strong>
              <p>{{ logData.po_date || '-' }}</p>
          </div>
          <div class="col-md-3">
              <strong>PO Value</strong>
              <p>Rp. {{ convertNumber(logData.po_value) || '0' }}</p>
          </div>
          <div class="col-md-3">
              <strong>Total DPP</strong>
              <p>Rp. {{ convertNumber(logData.total_dpp) || '0' }}</p>
          </div>

          <div class="col-md-3">
              <strong>Contract Name</strong>
              <p>{{ logData.contract_name || '-' }}</p>
          </div>
          <div class="col-md-3">
              <strong>Contract Detail</strong>
              <p>{{ logData.contract_detail_name || '-' }}</p>
          </div>
        </div>

        <!-- Tabel Detail Payment -->
        <!-- Tabel Detail Payment -->
        <h5 class="mt-3">Detail Payment</h5>
        <div class="table-responsive">
          <table class="table table-sm table-bordered">
            <thead class="thead-light">
              <tr>
                <th>Contract Item</th>
                <th>Term</th>
                <th>BAST Number</th>
                <th>BAST Date</th>
                <th>Vendor Name</th>
                <th>SES/GR Number</th>
                <th>INV Number</th>
                <th>DPP</th>
                <th>VAT</th>
                <th>After Tax</th>
                <th>WHT</th>
                <th>Net Value</th>
                <th>FA Form Date</th>
                <th>Doc To FA Date</th>
                <th>Payment Date</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="!logData.actual_budget_item || logData.actual_budget_item.length === 0">
                <td colspan="15" class="text-center">No payment details available</td>
              </tr>
              <template v-else>
                <tr v-for="(payment, index) in logData.actual_budget_item" :key="index">
                  <td>{{ payment.contract_item || '-' }}</td>
                  <td>{{ payment.term || '-' }}</td>
                  <td>{{ payment.bast_subject || '-' }}</td>
                  <td>{{ payment.bast_date || '-' }}</td>
                  <td>{{ payment.vendor_name }}</td>
                  <td>{{ payment.ses_gr_no_subject }}</td>
                  <td>{{ payment.inv_subject }}</td>
                  <td>Rp. {{ convertNumber(payment.dpp) || '0' }}</td>
                  <td>Rp. {{ convertNumber(payment.vat) || '0' }}</td>
                  <td>Rp. {{ convertNumber(payment.after_tax) || '0' }}</td>
                  <td>Rp. {{ convertNumber(payment.wht) || '0' }}</td>
                  <td>Rp. {{ convertNumber(payment.net_value) || '0' }}</td>
                  <td>{{ payment.fa_form }}</td>
                  <td>{{ payment.doc_to_fa }}</td>
                  <td>{{ payment.payment_date }}</td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>


        <!-- Update Value Section -->
        <div class="mt-4 p-3 border rounded bg-white">

          <div class="row align-items-center">
            <div class=" col-md-12 mb-3">
              <p class="font-weight-bold mb-2">Data Changes</p>
              <!-- <p class="font-weight-bold mb-2">Update 3 - 21 Januari 2025 14:05:43</p> -->
              <p class="mb-1">Update By <span class="font-weight-bold">{{ logData.data_changes ? logData.data_changes.updated_by : '-' }}</span></p>
              <p class="mb-0">Update At <span class="font-weight-bold">{{ logData.data_changes ? new Date(logData.data_changes.updated_at).toLocaleString() : '-' }}</span></p>
            </div>
          </div>
          <div v-for="(field, key) in comparisonData" :key="key" class="row align-items-center mb-2">
            <div class="col-md-3">
              <div class="border p-3 rounded bg-white text-dark">
                <div class="mb-3 bg-warning p-3 py-1 rounded" style="display: inline-block;">
                  <strong>Old Data</strong>
                </div>
                <div><strong>{{ key }}</strong></div>
                <p class="mb-0">{{ field.old_value }}</p>
              </div>
            </div>

            <div class="col-md-1 text-center">
              <strong>➝</strong>
            </div>

            <div class="col-md-3">
              <div class="border p-3 rounded bg-white text-dark">
                <div class="mb-3 bg-info p-3 py-1 rounded" style="display: inline-block;">
                  <strong>New Data</strong>
                </div>
                <div><strong>{{ key }}</strong></div>
                <p class="mb-0">{{ field.new_value }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import axiosIns from '@/api/axios';
import axios from 'axios';

export default {
  props: {
    showModal: Boolean, // Menerima state modal dari parent
    detail: Object, // Menerima data transaksi dari parent
  },
  data() {
    return {
      localShowModal: this.showModal, // Initialize with the prop value
      isLoading: true, // To show skeleton loader
      logData: {}, // To store the log data from API
      comparisonData: {}, // Store comparison of old and new values
    };
  },
  watch: {
    showModal(newVal) {
      this.localShowModal = newVal;
      if (newVal) {
        this.fetchHistoricalLog(); // Fetch data after modal is opened and DOM is updated
      }
    },
    localShowModal(newVal) {
      this.$emit('update:showModal', newVal);
    },
  },
  methods: {
    resetModal() {
      this.logData = {}; // Reset the log data
      this.comparisonData = {}; // Reset the comparison data
      this.isLoading = true; // Reset loading state
    },
    convertNumber(dat) {
      return (dat || 0).toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
    },
    fetchHistoricalLog() {
      this.isLoading = true; // Set loading state to true
      axiosIns
        .get(`/historical-log/${this.detail.id}`)
        .then((response) => {
          const data = response.data.data;
          this.logData = data.detail;
          this.logData.data_changes = data.data_changes;
          this.comparisonData = this.getComparisonData(data.data_changes.old_value, data.data_changes.new_value);
          this.isLoading = false; // Set loading state to false when data is fetched
          this.localShowModal = true; // Open modal
        })
        .catch((error) => {
          this.isLoading = true; // Stop loading if error occurs
          this.$swal("Error", error.response?.data?.error || "Terjadi kesalahan, tidak dapat mengambil data.", "error");
          this.localShowModal = false; // Close modal if error occurs
          this.resetModal();
          console.error('Error fetching historical log details:', error);
        });
    },
    formattedDate(date) {
      return date ? new Date(date).toLocaleString() : '-';
    },
    getComparisonData(old_value, new_value) {
      // Memastikan old_value dan new_value bukan undefined atau null
      const oldValue = old_value || {};
      const newValue = new_value || {};

      const filterKeysMapping = (keys) => {
        return keys
          .filter(key =>
            !key.includes('id') &&
            !key.includes('code_plan_budget') &&
            !key.includes('code_actual_budget') &&
            !key.includes('actual_budget_item')
          )
          .map(key => {
            let transformedKey = key;
            if (transformedKey.includes('subject')) {
              transformedKey = transformedKey.replace(/subject/gi, 'number');
            }
            transformedKey = transformedKey
              .replace(/(po|pr|im|gl)/gi, (match) => match.toUpperCase());
            return {
              original: key,
              transformed: transformedKey,
            };
          });
      }

      // Contoh pemakaian di kode pembanding data:
      const result = {};
      const oldMappings = filterKeysMapping(Object.keys(oldValue));
      const newMappings = filterKeysMapping(Object.keys(newValue));

      // Iterasi key dari oldValue
      oldMappings.forEach(mapping => {
        const formattedKey = this.formatKey(mapping.transformed);
        result[formattedKey] = {
          old_value: oldValue[mapping.original] || '-',
          new_value: newValue[mapping.original] || '-',
        };
      });

      // Tambahkan key yang ada di newValue tapi tidak di oldValue
      newMappings.forEach(mapping => {
        const formattedKey = this.formatKey(mapping.transformed);
        if (!result.hasOwnProperty(formattedKey)) {
          result[formattedKey] = {
            old_value: oldValue[mapping.original] || '-',
            new_value: newValue[mapping.original] || '-',
          };
        }
      });

      return result;
    },
    // Fungsi untuk mengubah key (mengganti "_" menjadi spasi dan kapitalisasi setiap kata)
    formatKey(key) {
      return key
        .replace(/_/g, ' ') // Ganti _ dengan spasi
        .replace(/\b\w/g, (char) => char.toUpperCase()); // Kapitalisasi setiap awal kata
    },
  },
  mounted() {
    this.fetchHistoricalLog(); // Fetch historical log details on mount
  },
};
</script>

<style>
.skeleton-loader {
  background-color: #e0e0e0;
  height: 20px;
  margin-bottom: 10px;
  border-radius: 4px;
}
</style>